import { RouterStore } from 'mobx-router';

const GuestRouter = {
  router: new RouterStore()
};

export default GuestRouter;
